module.exports = __webpack_public_path__ + "img/logo.71372556.png";